var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"hd-cl",on:{"dblclick":function($event){return _vm.clickH()}}},[_vm._v("z")]),(_vm.hidden)?_c('div',{staticClass:"hd-class"},[_c('img',{attrs:{"src":require("@/assets/gif/e-hide.gif"),"alt":""}})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }